import { FIELD_TYPES } from '../constants';
export function getSubmitFieldIds(fields = []) {
    return fields.flatMap(({ id, view })=>id && view?.fieldType === FIELD_TYPES.SUBMIT_BUTTON ? [
            id
        ] : []);
}
export function getSubmitFieldIdsV2(fields = []) {
    return fields.flatMap(({ id, identifier })=>id && identifier === FIELD_TYPES.SUBMIT_BUTTON ? [
            id
        ] : []);
}

//# sourceMappingURL=submit-field-ids.js.map